import { ShopSubscriptionType, SubscriptionScheduleType } from 'types/shopSubscription'
import { Stripe } from 'stripe'
import { FirebaseDocRefType } from 'firebase/index'

export const FETCH_SHOP_SUBSCRIPTIONS = 'FETCH_SHOP_SUBSCRIPTIONS'
export const fetchShopSubscriptionsAction = (
  shopSubscriptions: ShopSubscriptionType[],
  storeRefs: FirebaseDocRefType[]
) => {
  return {
    type: 'FETCH_SHOP_SUBSCRIPTIONS',
    payload: {
      shop_subscriptions: shopSubscriptions,
      store_refs: storeRefs,
    },
  }
}

export const INIT_SHOP_SUBSCRIPTIONS = 'INIT_SHOP_SUBSCRIPTIONS'
export const initShopSubscriptionsAction = () => {
  return {
    type: 'INIT_SHOP_SUBSCRIPTIONS',
    payload: null,
  }
}

export const RETRIEVE_INVOICES = 'RETRIEVE_INVOICES'
export const retrieveInvoicesAction = (invoices: Stripe.Invoice[]) => {
  return {
    type: 'RETRIEVE_INVOICES',
    payload: invoices,
  }
}

export const RETRIEVE_SUBSCRIPTIONS = 'RETRIEVE_SUBSCRIPTIONS'
export const retrieveSubscriptionsAction = (
  subscriptions: Stripe.Subscription[],
  subscriptionSchedules: SubscriptionScheduleType[]
) => {
  return {
    type: 'RETRIEVE_SUBSCRIPTIONS',
    payload: {
      subscriptions: subscriptions,
      subscription_schedules: subscriptionSchedules,
    },
  }
}
